import { useContext, useRef } from 'react'

import { Box, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ContentType } from '../../../../ContentManagementProvider/Context'
import ContentModalContext from '../../ContentModalProvider/Context'
import Section from '../../components/Section'
import ValidationMessage from '../../components/ValidationMessage'
import { ERROR_MESSAGES, FIELD_NAMES, LABELS } from '../../components/constants'

const useStyles = makeStyles((theme) => ({
  selectedChip: {
    backgroundColor: '#D9EEF8',
    '&.MuiChip-clickable.MuiChip-outlinedPrimary:focus': {
      backgroundColor: '#D9EEF8',
    },
  },
  chipLabel: {
    color: theme.palette.common.black,
  },
}))

const types = [
  { label: 'Overview', value: 'CollegeOverview' },
  { label: 'Academics', value: 'Academics' },
  { label: 'Admissions', value: 'Admissions' },
  { label: 'Cost & Aid', value: 'CostAndFinancialAid' },
  { label: 'Student Life', value: 'StudentLife' },
]

const SelectContentType = () => {
  const classes = useStyles()
  const { item, onUpdateField } = useContext(ContentModalContext)

  const value = item[FIELD_NAMES.CONTENT_TYPE]
  const touchedRef = useRef(false)
  const touched = touchedRef.current

  const onSelect = (newType: ContentType) => {
    touchedRef.current = true
    onUpdateField(FIELD_NAMES.CONTENT_TYPE, newType)
  }

  return (
    <Section
      title="Type *"
      subTitle={
        <Box
          mt={-2}
          mb={-2}
        >
          Control how this Post displays on your profile and in search results
        </Box>
      }
    >
      <Box
        display="flex"
        gridGap={8}
        flexWrap="wrap"
        mt={-1}
      >
        {types.map((t) => {
          const isSelected = t.value === value
          return (
            <Chip
              key={t.value}
              classes={{ root: isSelected ? classes.selectedChip : undefined, label: classes.chipLabel }}
              variant="outlined"
              color="primary"
              label={t.label}
              onClick={() => onSelect(t.value as ContentType)}
            />
          )
        })}
      </Box>
      <ValidationMessage
        label={LABELS.CONTENT_TYPE}
        touched={touched}
        valuesByError={{
          [ERROR_MESSAGES.REQUIRED]: value,
        }}
      />
    </Section>
  )
}

export default SelectContentType
